import axios from "axios";
import jwt from "jwt-decode";
import {
    GET_AUTH,
    GET_LOGOUT,
    GET_LOGIN,
    GET_AUTH_REFUSE,
} from "../types/types";
import { toastr } from "react-redux-toastr";

export const fetchLogin = (data) => async (dispatch) => {
    axios
        .post("https://shoppi-test.herokuapp.com/api/login", data)
        .then((result) => {
            localStorage.setItem("token", result.data.accessToken);
            dispatch({
                type: GET_LOGIN,
                payload: result.data,
            });
            dispatch(fetchAuth());
        })
        .catch((err) => {
            if (err) {
                toastr.error(err.response.data);
                dispatch({
                    type: GET_AUTH_REFUSE,
                    payload: err.response.data,
                });
            }
        });
};

export const fetchAuth = () => (dispatch) => {
    if (localStorage.getItem("token")) {
        const user = jwt(localStorage.getItem("token"));
        dispatch({
            type: GET_AUTH,
            payload: user,
        });
    } else {
        dispatch({
            type: GET_AUTH_REFUSE,
            payload: false,
        });
    }
};

export const fetchLogout = () => (dispatch) => {
    localStorage.removeItem("token");
    dispatch({
        type: GET_LOGOUT,
    });
};
